'use strict';
// @flow

import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { connect } from 'react-redux';

import * as modal from '../../../../reducers/modal';
import * as classificacao from '../../../../reducers/nfe/classificacao_fiscal';
import { withProvider } from '../../../../lib/reduxTools';

import ClassificaDocumento from './classifica_documento';

const mapStateToProps = createStructuredSelector({ open: modal.openModalSelector });

export default compose(
    withProvider(),
    connect(mapStateToProps, { ...modal, ...classificacao })
)(ClassificaDocumento);
